export { AiSparkleIcon } from "./OutreachedJobs";

export const OUTREACHED_TABS = [
    {
        label : "Ongoing Outreach",
        value : "outreached",
    },
    {
        label : "Applied",
        value : "applied",
    }
]

export const OUTREACHED_TABS_STATUS_MAPPER = {
    "outreached" : 0,
    "applied" : 1
}